module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-decoration-score-54218c05697557aec1e4f46bb1192e88.png";